import { useEffect, useState } from "react";

/* 10-16 (the hover row's brief) — DOES THIS SCREEN HAVE HOVER? The day card asks it in JavaScript for ONE reason: its `⋯`
 * lists only what no visible glyph does, and whether the pencil, Copy and 4-arrow are drawn is decided by the stylesheet's
 * `(any-hover: hover)` / `(any-hover: none)` blocks. The menu's list and the glyphs must answer the SAME question, or a card
 * offers an action twice (hover) or not at all (touch) — so the query is spelled here once and a ruler finds this exact text
 * in `direction.css` (`hoverRow20261016.test.ts`). It LISTENS, as `usePhoneWidth` does: a laptop that gains a mouse, or a
 * window moved between screens, answers again without a remount. */

/** The one spelling. `direction.css` hides the glyphs under its negation, `(any-hover: none)`. */
export const HOVER_QUERY = "(any-hover: hover)";

export function useAnyHover(): boolean {
  const [hover, setHover] = useState<boolean>(() => matches());
  useEffect(() => {
    /* No `matchMedia` (jsdom): TRUE, the laptop — William's screen and the shape the glyphs were built for. */
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(HOVER_QUERY);
    const onChange = () => { setHover(mql.matches); };
    onChange();
    mql.addEventListener("change", onChange);
    return () => { mql.removeEventListener("change", onChange); };
  }, []);
  return hover;
}

function matches(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return true;
  return window.matchMedia(HOVER_QUERY).matches;
}
